export default __webpack_public_path__ + "static/5-1--d0126da0899119a4e13bd4963f9fffa4.png";